import React from "react"
import TermsPrivacyAndGDPRWrapper from './TermsPrivacyAndGDPR.style'

// console.log(SLA_CONTENT)

const TermsPrivacyAndGDPR = ({ children }) => (
  <TermsPrivacyAndGDPRWrapper>
    <div className="TermsPrivacyAndGDPR">
      <div className="row expanded small-collapse">
        <div className="columns small-12 container">
          <div className="content-container">
            {children}
          </div>
        </div>
      </div>
    </div>
  </TermsPrivacyAndGDPRWrapper>
);

export default TermsPrivacyAndGDPR;